import {
  BottomPrimaryMenuItems,
  DefaultPrimaryMenu,
  AddNewUserPrimaryItem,
} from '@cld-remote/application_wrapper/index';
import { useAppContext } from '../../context/App.context.js';

export const CustomPrimaryMenu = () => {
  const { userData } = useAppContext();

  const bottomItems = (
    <>
      {(userData.role === 'masterAdmin' || userData.role === 'admin') && <AddNewUserPrimaryItem />}
      <BottomPrimaryMenuItems />
    </>
  );

  return <DefaultPrimaryMenu bottomItems={bottomItems} />;
};
